/*global HTMLStyleElement */

import React, { useEffect, useRef } from 'react';
import { themes } from '../../theme/theme';

const injectDatePickerStyles = () => {
  const css = `
  .datepicker * {
    font-family: 'SF Pro Text', sans-serif;
  }

  .datepicker.default {
    height: 300px;
    background-color: ${themes.light.white[1]};
    border-radius: 12px 12px 0 0;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  }

  .datepicker-divider-container {
    display: flex;
    justify-content: center;
  }

  .datepicker-divider {
    background-color: ${themes.light.gray_blue[5]};
    width: 48px;
    height: 4px;
    margin-top: 5px;
    margin-bottom: 2px;
    border-radius: 5px;
  }

  /* Header styling */
  .datepicker.default .datepicker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    color: ${themes.light.gray_blue[1]};
    font-size: 20px;
    font-weight: 600;
  }

  /* Close icon styling */
  .datepicker.default .datepicker-header .datepicker-close-icon {
    font-size: 15px;
    color: ${themes.light.white[1]};
    cursor: pointer;
    margin-left: 8px;
    background-color: ${themes.light.gray_blue[5]};
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  .datepicker .datepicker-viewport {
    height: 135px;
  }

  /* Date item styling */
  .datepicker.default .datepicker-content .date-item {
    color: #141A42;
    font-size: 16px;
  }

  .datepicker.default .datepicker-wheel {
    border-top: 1px solid ${themes.light.gray_blue[6]};
    border-bottom: 1px solid ${themes.light.gray_blue[6]};
  }

  .datepicker .datepicker-navbar {
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
    border-top: 1px solid #E6E8EC;
  }

  .datepicker.default .datepicker-navbar-btn:first-child {
    background-color: ${themes.light.teal[3]};
    color: white;
    font-size: 14px;
    font-weight: 600;
    border-radius: 12px;
    flex-grow: 2;
    margin-top: 6px;
  }

  .datepicker.default .datepicker-navbar-btn:last-child {
    color: ${themes.light.gray_blue[1]};
    font-size: 14px;
    font-weight: 600;
    border: 1px solid #E6E8EC;
    border-radius: 12px;
    flex-grow: 1;
    margin-top: 6px;
  }
 `;

  const styleTag = document.createElement('style');
  styleTag.type = 'text/css';
  styleTag.id = 'datepicker-styles';
  styleTag.appendChild(document.createTextNode(css));
  document.head.appendChild(styleTag);

  return styleTag;
};

const DatePickerStyleInjector: React.FC = () => {
  const isInjected = useRef(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-redeclare
    let styleTag: HTMLStyleElement | null = null;

    if (!isInjected.current) {
      styleTag = injectDatePickerStyles();
      isInjected.current = true;
    }

    return () => {
      if (styleTag) {
        styleTag.remove(); // Cleanup on unmount
        isInjected.current = false;
      }
    };
  }, []);

  return null;
};

export default DatePickerStyleInjector;
